<ng-template #spinner>
   <mat-spinner diameter="30" class="common-m1em"></mat-spinner>
</ng-template>

<ng-container *ngIf="!_loading else spinner">
   <mat-divider></mat-divider>

   <div class="filters wrapper" *ngIf="columns.size">
      <header [attr.color]="valid ? '' : 'warn'">FILTERS *</header>

      <ng-container *ngFor="let filter of filters.controls; index as i">
         <ng-container *ngIf="columns.get( filter.get('name').value ) as column">
            <div class="filter">
               <ng-container [ngSwitch]="column.type">
                  <span *ngSwitchCase="'number'">
                     <mat-form-field>
                        <mat-label>{{column.header}}</mat-label>
                        <input matInput type="number" [formControl]="filter.get('value')" required [pattern]="column?.validator" />
                        <mat-error libInputErrors [control]="filter.get('value')"></mat-error>
                     </mat-form-field>
                  </span>
                  <span *ngSwitchCase="'date'">
                     <mat-form-field class="common-mr1em">
                        <mat-select [formControl]="filter.get('relative')" (selectionChange)="filter.get('value').reset()">
                           <mat-option [value]="false">Pick a Date</mat-option>
                           <mat-option [value]="true">Calculate a Date</mat-option>
                        </mat-select>
                     </mat-form-field>
                     <ng-container *ngIf="filter.get('relative').value else default">
                        <lib-rdate-filter [placeholder]="column.header" ngDefaultControl [formControl]="filter.get('value')"></lib-rdate-filter>
                     </ng-container>
                     <ng-template #default>
                        <mat-form-field>
                           <mat-label>{{column.header}}</mat-label>
                           <input matInput [formControl]="filter.get('value')" [matDatepicker]="picker" required />
                           <mat-error libInputErrors [control]="filter.get('value')"></mat-error>
                           <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                           <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                     </ng-template>
                  </span>
                  <span *ngSwitchCase="'enum'">
                     <mat-form-field>
                        <mat-label>{{column.header}}</mat-label>
                        <mat-select [formControl]="filter.get('value')" required>
                           <mat-option *ngFor="let item of reportEnums[column.name]() | async" [value]="item">{{item | readable}}</mat-option>
                        </mat-select>
                        <mat-error libInputErrors [control]="filter.get('value')"></mat-error>
                     </mat-form-field>
                  </span>
                  <span *ngSwitchCase="'boolean'">
                     <mat-checkbox [checked]="filter.value.value">{{column.header}}</mat-checkbox>
                  </span>
                  <span *ngSwitchDefault>
                     <mat-form-field>
                        <mat-label>{{column.header}}</mat-label>
                        <input matInput [formControl]="filter.get('value')" required [pattern]="column?.validator" />
                        <mat-error libInputErrors [control]="filter.get('value')"></mat-error>
                     </mat-form-field>
                  </span>
               </ng-container>

               <div class="filter-buttons">
                  <button mat-icon-button (click)="filters.removeAt( i )" color="warn">
                     <mat-icon>close</mat-icon>
                  </button>
               </div>
            </div>
         </ng-container>
      </ng-container>

      <ng-container *ngIf="available$ | async as select">
         <div class="filter" *ngIf="select.length">
            <mat-form-field class="add-filter">
               <mat-select #add_select placeholder="Add Filter" (selectionChange)="add( $event.value ); add_select.value = '';">
                  <ng-container *ngFor="let filter of select">
                     <mat-option [value]="filter">
                        {{filter.header}}
                     </mat-option>
                  </ng-container>
               </mat-select>
            </mat-form-field>
         </div>
      </ng-container>
   </div>
</ng-container>
